import React from 'react';
import { css } from "@emotion/react";

import theme from "../../theme";
import { CORPORATE_URL } from "../../config/config";

const TermsAndConditions = () => {
    return (
        <div css={redirectLinksStyle}>
            <a
                href={CORPORATE_URL + "/terms-and-conditions"}
                css={linkWrapperStyle}
            >
                Terms & Conditions
            </a>
            <a
                href={CORPORATE_URL + "/privacy-policy"}
                css={linkWrapperStyle}
            >
                Privacy Policy
            </a>
        </div>
    )
}

export default TermsAndConditions;

const redirectLinksStyle = css`
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding-bottom: 30px;
    
    >a:first-of-type {
        margin-right: 50px;
    }
`;

const linkWrapperStyle = css`
    color: ${theme.colours.grey[650]};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
        color: ${theme.colours.grey[800]};
    }
`;